import request from '@/utils/request'

/**
 * 获取车辆信息报表
 * @param {*} data
 */
function getcarInfoReport(data) {
  return request({
    url: '/report/car/list',
    method: 'post',
    data
  })
}

/**
 * 获取车辆品牌
 * @param {*} data
 */
function getcarBrandList(data) {
  return request({
    url: '/report/car/brand',
    method: 'get',
    data
  })
}

/**
 * 获取车辆系列
 * @param {*} data
 */
function getseriesList(brandId) {
  return request({
    url: `/report/car/series/${brandId}`,
    method: 'get',
  })
}
/**
 * 导出车辆信息报表
 * @param {*} data
 */
function exportCar(data) {
  return request({
    url: '/report/car/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
export {
    getcarInfoReport,
    getcarBrandList,
    getseriesList,
    exportCar
  }
  